import { baseAnimation, CSS, fadeIn, fadeOut } from '@grupoboticario/flora-react-system'

export const OverlayStyles: CSS = {
  backgroundColor: '$disabledContent',
  position: 'fixed',
  inset: 0,
  zIndex: '$overlay',
  pointerEvents: 'auto',

  '&[data-state="open"]': {
    animation: `${fadeIn} ${baseAnimation}`,
  },

  '&[data-state="closed"]': {
    animation: `${fadeOut} ${baseAnimation}`,
  },
}

export const CloseButtonStyles: CSS = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  userSelect: 'none',
  backgroundColor: 'transparent',
  border: 'none',
  padding: '$2',
  borderRadius: '$small',
  position: 'absolute',
  right: '$5',
  top: '$5',
  cursor: 'pointer',
  fill: '$nonInteractiveAuxiliar',
  '&:hover': {
    '& svg path': {
      fill: '$linkHover',
    },
  },
}

export const HeaderStyles: CSS = {
  padding: '$5',
  color: '$backgroundAltSecondary',
  fontSize: '$subtitleDesk',
}

export const BodyStyles: CSS = {
  padding: '$5',
  overflowX: 'auto',
}

export const FooterStyles: CSS = {
  display: 'flex',
  justifyContent: 'flex-end',
  padding: '$5',
  gap: '$2',
}

export const TriggerStyles: CSS = {
  pointerEvents: 'visible',
}
